import { createAction, props } from '@ngrx/store';

export const SetActiveMediaQueries = createAction('[Media] SET_ACTIVE_MEDIA_QUERIES', props<{ activeMediaQueries: string[] }>());

